/**
 * Générateur — Il intègre une variable dans un programme de déplacement,
 * de construction géométrique ou de calcul.
 * Attendu ID : 249 | Niveau : 3ème | Domaine : Algorithmique (d21, O2 niv. 2)
 *
 * ⚠️ BANQUE 3e (doc muet — option (a) du TODO §5). Plan auto-validé
 * 2026-07-18 : « executer » (programme de calcul à variable : deux entrées,
 * deux sorties), « antecedent » (retrouver l'ENTRÉE depuis la sortie —
 * remonter le programme à l'envers, pont avec le calcul littéral 3e).
 */

import { randomChoice, randInt, makeTexteTrou } from '../../../utils';

const ATTENDU_ID = 249;
const L_EXECUTER = 'Exécuter un programme à variable';
const L_ANTECEDENT = 'Retrouver l\'entrée du programme';
const opts = (label) => ({ niveau: '3eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// ═════════ « executer » ═════════

const genExecuterTrous = () => {
    let a; let b; let x1; let x2; let s1; let s2;
    for (let essai = 0; essai < 40; essai++) {
        a = randInt(2, 6);
        b = randInt(3, 15);
        x1 = randInt(2, 9);
        x2 = randInt(2, 12);
        s1 = a * x1 + b;
        s2 = a * x2 + b;
        if (x1 !== x2 && s1 !== s2) break;
    }
    const phrase = `Pour l'entrée ${x1}, le programme dit {{${s1}}} ; pour l'entrée ${x2}, il dit {{${s2}}}.`;
    const payload = makeTexteTrou(phrase,
        '<p>Programme de calcul : demander un nombre x ; mettre Résultat à '
        + `(x × ${a} + ${b}) ; dire Résultat. La VARIABLE x change à chaque exécution, le programme reste `
        + 'le même.</p>'
        + `<p><b>Exécute le programme pour les entrées ${x1} puis ${x2}.</b></p>`,
        { ...opts(L_EXECUTER), mode: 'saisie' });
    payload._meta.params = { a, b, x1, x2, s1, s2 };
    return payload;
};

// ═════════ « antecedent » ═════════

const genAntecedentTrous = () => {
    let a; let b; let x; let sortie;
    for (let essai = 0; essai < 40; essai++) {
        a = randInt(2, 6);
        b = randInt(3, 15);
        x = randInt(3, 12);
        sortie = a * x + b;
        if (x !== sortie) break;
    }
    const phrase = `L'entrée était {{${x}}}.`;
    const payload = makeTexteTrou(phrase,
        '<p><code>demander un nombre x ; mettre Résultat à '
        + `(x × ${a} + ${b}) ; dire Résultat</code>. Le programme a dit « ${sortie} ».</p>`
        // « retranche b, puis divise par a » était la résolution complète.
        + '<p><b>Quel nombre avait été entré ?</b></p>',
        { ...opts(L_ANTECEDENT), mode: 'saisie' });
    payload._meta.params = { a, b, x, sortie };
    return payload;
};

const GENERATORS = {
    executer_texte_trou_saisie: genExecuterTrous,
    antecedent_texte_trou_saisie: genAntecedentTrous,
};
const FORMAT_LABELS = { texte_trou_saisie: 'Saisie trous' };
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter(k => k.startsWith(`${prefix}_`))
        .map(k => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));
export const CATEGORIES = [
    { id: 'executer', label: L_EXECUTER, formatsList: buildFormats('executer') },
    { id: 'antecedent', label: L_ANTECEDENT, formatsList: buildFormats('antecedent') },
];
export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter(k => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
